import { type definitions } from '@luxuryescapes/contract-svc-agent'
import request, { authOptions } from 'api/requestUtils'

export async function requestPatchCustomerId(agentId: string, customerId: string): Promise<definitions['userSimpleSchema']> {
  const response = await request.patch<App.ApiResponse<definitions['userSimpleSchema']>, { customerId: string }>(`/api/agent/user/${agentId}/member-id`, {
    customerId,
  }, authOptions())

  return response.result
}
